import React, {ReactEventHandler} from 'react';
import {getYoutubeThumbFromUrl} from './video-utils';

type Props = {
  url: string;
  clickHandler: ReactEventHandler;
  className?: string;
};

export const YoutubePoster = ({
  url,
  clickHandler,
  className,
  ...rest
}: Props) => {
  const placeholder = getYoutubeThumbFromUrl(url);

  return (
    <img
      src={placeholder}
      alt=""
      onClick={clickHandler}
      className={className}
      {...rest}
    />
  );
};
